export enum AvailabilityMode {
  ALL = "all",
  ANY = "any",
}
